module.exports = __webpack_public_path__ + "img/Jump Casting42.8531facb.jpg";